import { render, staticRenderFns } from "./BridgePart.vue?vue&type=template&id=f678b96a&scoped=true"
import script from "./BridgePart.vue?vue&type=script&lang=js"
export * from "./BridgePart.vue?vue&type=script&lang=js"
import style0 from "./BridgePart.vue?vue&type=style&index=0&id=f678b96a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f678b96a",
  null
  
)

export default component.exports